import React, { useEffect, useState } from "react";
import AboutBannerImage1 from "../../src/assets/images/dna1.png";
import { useNavigate } from "react-router-dom";
import { getAllCourses } from "../api/api";
import { FaRocket, FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import AccessPopup from "./AccessPopup";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

const StarRating = ({ rating }) => {
    const numRating = parseFloat(rating) || 0;
    const fullStars = Math.floor(numRating);
    const hasHalfStar = numRating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
        <div className="flex items-center text-yellow-400 text-xs">
            {[...Array(fullStars)].map((_, i) => (
                <FaStar key={`full-${i}`} />
            ))}
            {hasHalfStar && <FaStarHalfAlt />}
            {[...Array(emptyStars)].map((_, i) => (
                <FaRegStar key={`empty-${i}`} className="text-gray-300" />
            ))}
        </div>
    );
};

const FeaturedCourses = () => {

    const navigate = useNavigate();

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);



    useEffect(() => {
        const fetchCourses = async () => {
            try {
                setLoading(true);
                const response = await getAllCourses();
                console.log("Courses API Response:", response);

                if (response && response.success === true) {
                    const mappedCourses = response.courses.map(course => ({
                        id: course.id,
                        slug: course.slug,
                        title: course.title,
                        instructor: course.instructor_name,
                        category: course.category,
                        duration: course.duration_display || "N/A",
                        rating: course.rating_display || "4.0",
                        price: course.price,
                        discounted_price: course.discounted_price,
                        early_bird_price: course.early_bird_price,
                        price_formatted: course.price_formatted,
                        discounted_price_formatted: course.discounted_price_formatted,
                        early_bird_price_formatted: course.early_bird_price_formatted,
                        image: course.image_url || AboutBannerImage1,
                        is_bestseller: course.is_bestseller || false,
                        discount_percentage: course.discount_percentage,
                        is_coming_soon_status: course.is_coming_soon_status,
                        has_discount: course.discounted_price && course.discounted_price < course.price
                    }));

                    setCourses(mappedCourses);
                    setError(null);
                } else {
                    console.error("Failed to load courses:", response?.message);
                    setCourses([]);
                    setError(response?.message || "No courses found");
                }
            } catch (error) {
                console.error("Error fetching courses:", error);
                setCourses([]);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, []);

    const handleEnrollNow = (slug) => {
        navigate(`/courses-details/${slug}`);
    };



    const handleCardClick = (course, e) => {
        if (e.target.closest("button")) {
            return;
        }
        navigate(`/courses-details/${course.slug}`);
    };

    if (loading) {
        return (
            <div className="bg-[#eeeeee] py-20 flex justify-center">
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" />
            </div>
        );
    }

    return (
        <div
            id="featured-courses"
            className="bg-[#eeeeee] custom-padding xl-screen-padding pt-80 pb-80"
        >
            <div className="flex justify-between items-center mb-8">
                <div>
                    <h2 className="text-[28px] font-bold text-[#16372f] mt-4">
                        Explore Our Featured Courses
                    </h2>
                </div>
                <button
                    onClick={() => navigate('/all-courses')}
                    className="border border-[#15803d] text-[#15803d] px-5 py-2 rounded-md text-xs hover:bg-[#15803d] hover:text-white transition-colors"
                >
                    View All Courses
                </button>
            </div>

            {courses.length > 0 ? (
                <Swiper
                    modules={[Pagination, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    pagination={{
                        clickable: true,
                        dynamicBullets: false
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1280: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        },
                    }}
                    className="mySwiper"
                >
                    {courses.map(course => (
                        <SwiperSlide key={course.id}>
                            <div
                                onClick={(e) => handleCardClick(course, e)}
                                className="bg-white rounded-lg overflow-hidden shadow-sm cursor-pointer transition-transform hover:scale-105 h-full flex flex-col"
                            >
                                {/* Image */}
                                <div className="relative flex-shrink-0">
                                    <img
                                        src={course.image}
                                        alt={course.title}
                                        className="w-full h-[170px] object-cover"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = AboutBannerImage1;
                                        }}
                                    />

                                    {!course.is_coming_soon_status && course.is_bestseller && (
                                        <span className="absolute top-2 right-2 bg-[#6dbe45] text-white text-[9px] px-2 py-1 rounded-full font-bold">
                                            BESTSELLER
                                        </span>
                                    )}
                                    {course.is_coming_soon_status && (
                                        <span className="absolute top-3 right-2 bg-[#ff7a1a] text-white text-[9px] px-2 py-1 rounded-full font-bold">
                                            COMING SOON
                                        </span>
                                    )}
                                </div>
                                <div className="p-4 flex flex-col flex-grow">
                                    <div className="flex-grow">
                                        <p className="text-[10px] uppercase text-[#16a34a] font-bold">
                                            {course.category}
                                        </p>

                                        <h3 className="text-sm font-bold mt-2 text-gray-800 line-clamp-2 min-h-[40px]">
                                            {course.title}
                                        </h3>

                                        <div className="flex justify-between items-center mt-2">
                                            <p className="text-xs text-gray-500">
                                                {course.instructor}
                                            </p>

                                            {!course.is_coming_soon_status ? (
                                                <div className="flex items-center gap-1 flex-shrink-0">
                                                    <span className="text-xs text-gray-500">
                                                        {parseFloat(course.rating).toFixed(1)}
                                                    </span>
                                                    <StarRating rating={course.rating} />
                                                </div>
                                            ) : (
                                                <div className="w-[55px]"></div>
                                            )}
                                        </div>
                                        <div className="mt-4 min-h-[40px]">
                                            {course.is_coming_soon_status ? (
                                                <div className="flex justify-between items-center">
                                                    <span className="font-bold text-sm text-gray-600">
                                                        Price on launch
                                                    </span>
                                                    <span className="text-xs text-gray-400">
                                                        ⏱ {course.duration}
                                                    </span>
                                                </div>
                                            ) : (
                                                <>
                                                    {course.early_bird_price && parseFloat(course.early_bird_price) > 0 ? (
                                                        <div className="flex justify-between items-center">
                                                            <div className="flex items-center gap-2">
                                                                <span className="text-green-600 font-bold text-sm">
                                                                    {course.early_bird_price_formatted || `₹${parseFloat(course.early_bird_price).toLocaleString('en-IN')}`}
                                                                </span>
                                                                <span className="text-gray-400 text-xs line-through">
                                                                    {course.price_formatted}
                                                                </span>
                                                                {course.discount_percentage > 0 && (
                                                                    <span className="text-red-500 text-[10px] font-semibold">
                                                                        {course.discount_percentage}% OFF
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <span className="text-xs text-gray-400">
                                                                ⏱ {course.duration}
                                                            </span>
                                                        </div>
                                                    ) : course.discounted_price && parseFloat(course.discounted_price) > 0 && parseFloat(course.discounted_price) < parseFloat(course.price) ? (
                                                        <div className="flex justify-between items-center">
                                                            <div className="flex items-center gap-2">
                                                                <span className="text-green-600 font-bold text-sm">
                                                                    {course.discounted_price_formatted}
                                                                </span>
                                                                <span className="text-gray-400 text-xs line-through">
                                                                    {course.price_formatted}
                                                                </span>
                                                                {course.discount_percentage > 0 && (
                                                                    <span className="text-red-500 text-[10px] font-semibold">
                                                                        {course.discount_percentage}% OFF
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <span className="text-xs text-gray-400">
                                                                ⏱ {course.duration}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        /* Show Original Price with duration */
                                                        <div className="flex justify-between items-center">
                                                            <span className="font-bold text-sm">
                                                                {course.price_formatted}
                                                            </span>
                                                            <span className="text-xs text-gray-400">
                                                                ⏱ {course.duration}
                                                            </span>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    <div className="mt-0 h-[40px]">
                                        {!course.is_coming_soon_status ? (
                                          <button
    onClick={() => navigate(`/courses-details/${course.slug}`)}
    className="w-full bg-[#6dbe45] hover:bg-[#5bb532] text-white text-xs px-4 py-2 rounded-md font-bold transition-colors cursor-pointer"
>
    Buy Now
</button>
                                        ) : (
                                            <button
                                                disabled
                                                className="w-full bg-gray-400 text-white text-xs px-4 py-2 rounded-md font-bold cursor-not-allowed flex items-center justify-center gap-2 opacity-70"
                                            >
                                                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                                                </svg>
                                                Notify Me
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                !loading && !error && (
                    <p className="text-center text-gray-500">No courses available at the moment.</p>
                )
            )}

            {error && (
                <p className="text-red-500 text-center mt-5">
                    Error loading courses: {error}
                </p>
            )}

          
        </div>
    );
};

export default FeaturedCourses;